export default __webpack_public_path__ + "static/media/Poppins-Regular.9171031e.ttf";